<script>
	import Layout from "../../layouts/main";
	import PageHeader from "../../components/page-header";
	import { itemService, reportService } from "../../services";
	import { success_message, error_message } from "../../Helper/helper";
	import Swal from "sweetalert2";
	import pagination from "laravel-vue-pagination";
	import config from "../../config";

	export default {
		components: { Layout, PageHeader, pagination },
		data() {
			return {
				config: config,
				itemRatings: [],
				fields: [
						{ key: 'id', label: ' ' },  // More meaningful key instead of '#'
						{ key: 'order_id', label: 'Order ID', sortable : true },
						{ key: 'item_name', label: 'Item Name', sortable : false },
						{ key: 'customer_name', label: 'Customer Name', sortable : false },
						{ key: 'restaurant_name', label: 'Restaurant Name', sortable : false },
						{ key: 'rating', label: 'Rating', sortable : true },
						{ key: 'date', label: 'Created At', sortable : true },
						{ key: 'action', label: 'Actions' }  // Ensuring consistency
					],
				loading: false,
				sortBy: 'created_at',
				sortDesc: true,
				selectedIds: [], // Store checked checkbox IDs,
				restaurant: [],
				restaurant_id: '',
				paginations: {},
				limit: 10,
				selectAll: false // New property for select all checkbox
			};
		},
		mounted() {
			this.getItemRatings();
			this.getRestaurants();
		},
		methods: {
			getItemRatings(page = 1) {
				this.loading = true;
				itemService
					.getItemRatings({ 
						restaurant_id: this.restaurant_id,
						sortBy: this.sortBy,
						orderBy: this.sortDesc ? "desc" : "asc",
						vendor_id: this.$auth.getVendorId(),
						page: page
					})
					.then((response) => {
						this.loading = false;
						this.itemRatings = response.data.result.data;
						this.paginations = response.data.result;
						this.selectAll = false; // Reset select all when new data is loaded
						this.selectedIds = []; // Reset selected IDs

						console.log(this.restaurant_id);
						
					})
					.catch((error) => {
						this.loading = false;
						error_message(error);
					});
			},
			deleteRating(id = null) 
			{
				if (this.selectedIds.length == 0 && id == null)
				{
					error_message("Please select at least one item to delete.");
					return;
				}

				const idsToDelete = id ? [id] : this.selectedIds;
				
  				if (idsToDelete.length === 0) return;
				Swal.fire({
					title: "Are you sure?",
					text: "You won't be able to revert this!",
					icon: "warning",
					showCancelButton: true,
					confirmButtonColor: "#34c38f",
					cancelButtonColor: "#f46a6a",
					confirmButtonText: "Yes, delete it!"
				})
				.then((result) => {
					if (result.value) {
						this.loading = true;
						// Call API to delete selected items
						itemService
							.deleteItemRating({ids: idsToDelete})
							.then((response) => {
								this.loading = false;
								if(response.data.code == 200)
								{
									success_message(response.data.message);
									this.getItemRatings();
									this.selectedIds = [];
									this.selectAll = false;
								}
								else
								{
									error_message(response.data.message);
								}
							})
							.catch((error) => {
								this.loading = false;
								error_message(error);
							});
					}
				})
			},
			getRestaurants(){
				this.restaurant = [];
				reportService.getAllRestaurantName({
					country_id: this.country,
					state_id: this.state,
					city_id: this.city
				}).then((response) => {
					this.restaurant = response.data.result;
					// this.restaurant_id = this.restaurant[0].restaurant_id;	
				});
			},
			searchData() {
				this.getItemRatings();
			},
			sortingChanged(ctx) {
				this.sortBy = ctx.sortBy;
				this.sortDesc = ctx.sortDesc;
				
				this.getItemRatings();
			},
			toggleSelectAll() {
				if (this.selectAll) {
					this.selectedIds = this.itemRatings.map(item => item.rating_id);
				} else {
					this.selectedIds = [];
				}
			}
		},
		watch: {
			selectedIds(newVal) {
				// Update selectAll based on whether all items are selected
				this.selectAll = newVal.length === this.itemRatings.length && this.itemRatings.length > 0;
			}
		}
	}
</script>

<template>
	<Layout>
		<div>
			<!-- Header  -->
			<div class="row">
				<div class="col-12">
					<div class="page-title-box d-flex align-items-center justify-content-between icon-main-page">
						<div class="page-title-left">
							<div class="avatar-xs mr-3">
							<span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
								<i class="bx bx-user-circle"></i>
							</span>
							</div>
							<h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Item Ratings') }}</h4>
						</div>
						<div class="page-title-right">
							
						</div>
					</div>
				</div>
			</div>

			<!-- Table and Filter  -->
			<div class="row list-table-main">
				<div class="col-12">
					<div class="card">
						<div class="card-body">

							<!-- Filter -->
							<div class="row">
								<div class="col-sm-6">
									<button @click="deleteRating()" class="btn btn-danger" v-if="$auth.hasPermission(config.permissions.item_rating_write) && itemRatings.length > 0">{{trans.get('__JSON__.Delete Selected Ratings')}}</button>
								</div>
								<div class="col-sm-6">
									<div class="form-group float-right">
										<div class="date-range-list">
											<label>{{ trans.get('__JSON__.Restaurant') }} :</label>
											<select class="custom-select" v-model="restaurant_id" @change="searchData()">
												<option value selected>{{ trans.trans('__JSON__.All Vendor',{ vendor: $auth.setting.restaurant_name }) }}</option>
												<option v-for="res in restaurant" :value="res.restaurant_id" :key="res.restaurant_id">{{res.name}}</option>
											</select>
										</div>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-12 table-main-list table-responsive">
									<b-table
									:items="itemRatings"
									:fields="fields"
									:sort-by.sync="sortBy"
									:sort-desc.sync="sortDesc"
									:no-local-sorting="true"
									:busy="loading"
									show-empty
									@sort-changed="sortingChanged"
									>
									<template #table-busy>
										<div class="text-center text-danger my-2">
										<b-spinner class="align-middle"></b-spinner>
										<strong>{{trans.get('__JSON__.Loading...')}}</strong>
										</div>
									</template>

									<template v-slot:head(id) v-if="itemRatings.length > 0">
										<div class="custom-control custom-checkbox custom-checkbox-right">
											<input type="checkbox" 
												class="custom-control-input" 
												id="selectAll"
												v-model="selectAll"
												@change="toggleSelectAll"
											/>
											<label for="selectAll" class="custom-control-label"></label>
										</div>
									</template>

									<template v-slot:cell(id)="data">
										<div class="custom-control custom-checkbox custom-checkbox-right mb-3">
											<input type="checkbox" 
												class="custom-control-input" 
												:id="'item_rating_' + data.item.rating_id" 
												:value="data.item.rating_id"
												v-model="selectedIds" />
											<label :for="'item_rating_' + data.item.rating_id" class="custom-control-label"></label>
										</div>
									</template>

									<template v-slot:cell(rating)="data">
										<div v-if="data.item.rating <= 2">
										<span class="badge badge-danger font-size-12">
											<i class="mdi mdi-star mr-1"></i>
											{{parseFloat(data.item.rating).toFixed(2)}}
										</span>
										</div>
										<div v-else>
										<span class="badge badge-success font-size-12">
											<i class="mdi mdi-star mr-1"></i>
											{{parseFloat(data.item.rating).toFixed(2)}}
										</span>
										</div>
									</template>

									<template v-slot:cell(date)="data">
										{{ data.item.date ? data.item.date : '-' }}
									</template>

									<template v-slot:cell(action)="data">
										<b-button variant="danger" class="btn-sm btn-rounded" @click="deleteRating(data.item.rating_id)" v-if="$auth.hasPermission(config.permissions.item_rating_write)">{{trans.get('__JSON__.Delete')}}</b-button>
									</template>

									<template #empty>
										<p class="text-center">{{ trans.get('__JSON__.No Item Ratings Found') }}</p>
									</template>
									</b-table>
								</div>
								<div class="row col-sm-5 offset-sm-7">
									<div class="col">
										<div class="dataTables_paginate paging_simple_numbers float-right">
											<ul class="pagination pagination-rounded mb-0">
											<pagination
												:data="paginations"
												:limit="limit"
												@pagination-change-page="getItemRatings"
												></pagination>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

	  	</div>
	</Layout>
</template>